// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1tCTp","insightsList":"newBusinessInsightsMenu_insightsList__39cs_","active":"newBusinessInsightsMenu_active__3E8TV"};